import { differenceInHours, formatDistanceToNowStrict, isValid, parse, parseISO } from 'date-fns';

const ISO_DATE_WITH_NO_TIMEZONE_REGEX = new RegExp('^(d{4})-(d{2})-(d{2})T(d{2}):(d{2}):(d{2}(?:.d*)?)([-+](d{2}):(d{2}))?$');
const US_SHORT_DATE_REGEX = new RegExp(/^(0[1-9]|1[0-2])\/([0-2][0-9]|3[01])\/\d{2} ([0][1-9]|1[0-2]):[0-5][0-9](AM|PM)$/i);
const ZULU_ZONE_CHAR = 'Z';

export const US_SHORT_DATETIME_FORMAT = 'MM/dd/yy hh:mma'; // e.g: 01/01/24 12:34PM

export function getDateStringAsLocaleString(dateString: string | null | undefined, includeTime: boolean = false): string {
    if (dateString && isValid(parseISO(dateString))) {
        dateString = setDateStringAsUTCIfNotTimezoneIsDefined(dateString);
        const date = parseISO(dateString);
        return includeTime
            ? date.toLocaleString(undefined, {
                  dateStyle: 'short',
                  timeStyle: 'short',
              })
            : date.toLocaleDateString(undefined, { dateStyle: 'short' });
    }

    return '';
}

export function parseDate(dateString: string | null | undefined): Date | undefined {
    if (!dateString) {
        return undefined;
    }

    // we can add more date matchers if necessary, currently we only need these
    if (US_SHORT_DATE_REGEX.test(dateString)) {
        return parse(dateString, US_SHORT_DATETIME_FORMAT, new Date());
    } else if (isValid(parseISO(dateString))) {
        return parseISO(dateString);
    }

    return undefined;
}

export function setDateStringAsUTCIfNotTimezoneIsDefined(dateString: string): string {
    if (ISO_DATE_WITH_NO_TIMEZONE_REGEX.test(dateString)) {
        return dateString;
    }

    return dateString + ZULU_ZONE_CHAR;
}

export function getHourDifferenceToNow(dateString: string | null | undefined): number {
    if (dateString && isValid(parseISO(dateString))) {
        const date = parseISO(dateString);
        return differenceInHours(Date.now(), date);
    }

    return 0;
}

export function getFormattedDistanceToNowStrict(dateString: string | null | undefined): string {
    if (dateString && isValid(parseISO(dateString))) {
        const date = parseISO(dateString);
        return formatDistanceToNowStrict(date, { addSuffix: true });
    }

    return '';
}

export function dateSortComparer(reference: string, comparer: string): number {
    const referenceDate = parseDate(reference) as Date;
    const comparerDate = parseDate(comparer) as Date;
    if (referenceDate < comparerDate) {
        return -1;
    }
    if (referenceDate > comparerDate) {
        return 1;
    }
    return 0;
}
